import httpService from "app/services/httpService";
import config from "config.json";

const { apiUrl } = config;

const getUsersList = async (query) => {
  try {
    const url = `${apiUrl}/authenticate/users${query ? `?${query}` : ""}`;
    const { data } = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
const addUserData = async (values) => {
  try {
    const url = `${apiUrl}/authenticate/users`;
    const { data } = await httpService.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};

const editUserData = async (userId, values) => {
  try {
    const url = `${apiUrl}/authenticate/users/${userId}/update`;
    const { data } = await httpService.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};
export { getUsersList, addUserData, editUserData };
